import { Directive, ElementRef, Renderer2, Input, AfterViewInit, OnInit } from '@angular/core';
import { isEmpty, forEach, isUndefined } from 'lodash';
@Directive({
	selector: '[gtm-handler]',
})
export class GtmHandler implements AfterViewInit {
	dataLayer: any;
	gtmHandler: gtmHandler;
	@Input() events: string;
	@Input() handlerType: any;
	@Input() attributeVal: any;
	@Input() dataVal: any;
	@Input() label: any;
	@Input() value: any;
	@Input() action: any;

	constructor(private el: ElementRef, private renderer: Renderer2) {}

	ngAfterViewInit() {
		var arr = this.events.split(',');
		forEach(arr, (event) => {
			if (this.attributeVal) {
				this.renderer.setAttribute(this.el.nativeElement, 'gtm', this.attributeVal);
			}
			this.renderer.listen(this.el.nativeElement, event, (event) => {
				this.dataLayer = (<any>window).dataLayer;

				if (!isUndefined(this.dataLayer)) {
					switch (this.handlerType) {
						case 'button':
							if (this.label) {
							}
							break;

						case 'checkbox':
							let dataValue = this.value ? 'Check' : 'Uncheck';
							if (this.dataVal) {
								dataValue = this.dataVal;
							}
							break;

						case 'radio':
							if (this.value && this.value.trim) {
								this.value = this.value.trim();
							}
							break;

						case 'dataValue':
							break;

						case 'multiValue':
							break;
					}
				}
			});
		});
	}
}
